exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.msg-wrapper[data-v-5ef48958] {\n  background-color: red;\n}\n", "", {"version":3,"sources":["D:/webspace/cnc/src/src/app.vue"],"names":[],"mappings":";AA0BA;EACA,sBAAA;CACA","file":"app.vue","sourcesContent":["<template>\r\n    <div class=\"msg-wrapper\">\r\n        <span>hello!</span>\r\n        <span class=\"account\">{{data.name}}</span>\r\n    </div>\r\n</template>\r\n<script>\r\n    export default {\r\n        name:'Msg',\r\n        data () {\r\n            return {}\r\n        },\r\n        props:{\r\n            data:{\r\n                type:Object\r\n            }\r\n        },\r\n        methods: {\r\n\r\n        },\r\n        created(){\r\n            let that = this;\r\n        }\r\n    }\r\n</script>\r\n<style scoped>\r\n   .msg-wrapper {\r\n     background-color: red;\r\n    }\r\n</style>\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ef48958","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app.vue
// module id = 4
// module chunks = 0